import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AddProgramDetails } from "../../actions/skill";
import Spinner from "../layout/Spinner";

const AddProgram = ({
  onAddModalChange,
  auth: { isAuthenticated, user, users, loading },
  AddProgramDetails,
}) => {
  //formData
  const [formData, setFormData] = useState({
    programName: "",
    programDescription: "",
    isSubmitted: false,
  });
  const { programName, programDescription } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      programName: programName,
      programDescription: programDescription,
      programEnteredById: user._id,
      programEnteredDateTime: new Date().toLocaleString("en-GB"),
      institutionId: user.institutionId,
    };
    AddProgramDetails(finalData);
    onAddModalChange(true);
    setFormData({
      ...formData,
      programName: "",
      programDescription: "",
      isSubmitted: true,
    });
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form className="row" onSubmit={(e) => onSubmit(e)} autoComplete="off">
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control"> Program Name* :</label>
              <input
                type="text"
                name="programName"
                value={programName}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control">Description* :</label>
              <textarea
                name="programDescription"
                value={programDescription}
                id="programDescription"
                className="textarea form-control"
                rows="4"
                placeholder="Description"
                onChange={(e) => onInputChange(e)}
                style={{ width: "100%" }}
                required
              ></textarea>
            </div>
          </div>

          <div className="col-md-10 col-lg-10 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Save"
                value="Submit"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

AddProgram.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  skill: PropTypes.object.isRequired,
  AddProgramDetails: PropTypes.func.isRequired,
  savedMessage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  skill: state.skill,
  savedMessage: state.auth.savedMessage,
});

export default connect(mapStateToProps, {
  AddProgramDetails,
})(AddProgram);
